// Lightweight helper to open native date/time pickers when available
// Returns true when an action (showPicker or focus) was performed.
export const openDatePicker = (el) => {
  if (!el) return false;

  // If a container (not an input) was passed, try to find an input child
  let target = el;
  try {
    const tag = (el && el.tagName) || '';
    if (typeof tag === 'string' && tag.toUpperCase() !== 'INPUT') {
      const found = el.querySelector && (el.querySelector('input[type="date"]') || el.querySelector('input[type="datetime-local"]') || el.querySelector('input[type="time"]'));
      if (found) target = found;
    }
  } catch {
    // if querySelector throws for non-DOM objects, ignore and treat el as target
    // (e.g., in tests a plain object may be passed)
  }

  try {
    if (target && typeof target.showPicker === 'function') {
      target.showPicker();
      return true;
    }
  } catch {
    // ignore errors from showPicker
  }

  if (target && typeof target.focus === 'function') {
    target.focus();
    return true;
  }

  return false;
};

export default openDatePicker;
